import { useTranslation } from 'react-i18next';
import { Button, Dialog } from '@/components/ui';

export function TourWelcomeModal(props: {
  isOpen: boolean;
  title: string;
  description: string;
  onClose: () => void;
  onStart: () => void;
}) {
  const { isOpen, title, description, onClose, onStart } = props;
  const { t } = useTranslation();

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      title={title}
      size="sm"
      placement="center"
      closeLabel={t('common.close')}
      footer={
        <>
          <Button type="button" variant="secondary" size="sm" onClick={onClose}>
            {t('tour.skip')}
          </Button>
          <Button type="button" variant="primary" size="sm" onClick={onStart}>
            {t('tour.start')}
          </Button>
        </>
      }
    >
      <p className="m-0 font-ui text-small text-secondary">{description}</p>
    </Dialog>
  );
}
